import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const CategoryEmptyState = {
  categories: [],
  selectedCategory: null,
  selectedDashboardCategory: [],
};

export const CategoryKey = 'categories';

export const categoriesSlice = createSlice({
  name: 'categories',
  initialState: getLocalStorage(LocalStorageTypes.CATEGORIES)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.CATEGORIES))
    : CategoryEmptyState,
  reducers: {
    setCategories: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.CATEGORIES, result);
      return { ...state, ...action.payload };
    },
    updateSelected: (state, action) => {
      const result = { ...state, ...action.payload };
      persistLocalStorage(CategoryKey, result);
      return { ...state, ...action.payload };
    },
    updateSelectedDashboardCategory: (state, action) => {
      const result = { ...state, ...action.payload };
      persistLocalStorage(CategoryKey, result);
      return { ...state, ...action.payload };
    },
    resetCategories: () => {
      clearLocalStorage('categories');
      return CategoryEmptyState;
    },
  },
});

export const {
  setCategories,
  updateSelected,
  updateSelectedDashboardCategory,
  resetCategories,
} = categoriesSlice.actions;
